import { GalleryContext } from "./chunk-JMBPVZMW.js";

// src/components/Gallery/Gallery.tsx
import { useState, useMemo, useCallback, useRef, useEffect } from "react";
import { jsx } from "react/jsx-runtime";
var Gallery = _ref => {
  let {
    id,
    children,
    defaultActiveItem = 1,
    onChangeActiveItem,
    prevButton,
    nextButton,
    zoomButton,
    secondaryAction
  } = _ref;
  const [activeItem, setActiveItem] = useState(defaultActiveItem);
  const [totalItems, setTotalItems] = useState(1);
  const previousItem = useRef(activeItem);
  const handleChangeActiveItem = useCallback(item => {
    setActiveItem(item);
    onChangeActiveItem == null ? void 0 : onChangeActiveItem(item, previousItem.current);
  }, [onChangeActiveItem]);
  const context = useMemo(() => ({
    id,
    prevButton,
    nextButton,
    secondaryAction: secondaryAction || zoomButton,
    activeItem,
    setActiveItem: handleChangeActiveItem,
    totalItems,
    setTotalItems,
    previousItem: previousItem.current
  }), [id, prevButton, nextButton, zoomButton, secondaryAction, activeItem, handleChangeActiveItem, totalItems]);
  useEffect(() => {
    previousItem.current = activeItem;
  }, [activeItem]);
  return /* @__PURE__ */jsx(GalleryContext.Provider, {
    value: context,
    children: typeof children === "function" ? children(context) : children
  });
};
var Gallery_default = Gallery;
export { Gallery_default };